"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8557],{

/***/ 5297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_fast_marquee__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97005);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);




const CustomersMarquee = (param)=>{
    let { customersData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full overflow-visible relative h-fit",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "marquee-container relative overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_fast_marquee__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                gradient: false,
                speed: 40,
                className: " overflow-hidden p-2 rounded-md",
                children: customersData.map((card, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-surface text-black rounded-2xl px-11 py-16 mx-2 flex flex-col justify-between h-[520px] w-[390px] border border-surface-dark",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "bg-surface-dark rounded-md font-semibold px-4 py-2 text-gray-700 uppercase ",
                                    children: card.tag
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "inline-flex justify-center items-center p-3 bg-white rounded-xl border border-surface-dark",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/testimonials/comapnies/").concat(card.logo),
                                        alt: "Company Logo",
                                        className: "h-auto",
                                        width: 100,
                                        height: 100
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[18px] leading-[26px] text-black font-medium mb-6",
                                children: card.quote
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-semibold text-xl",
                                        children: card.author
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-base text-gray-500",
                                        children: card.authorTitle
                                    })
                                ]
                            })
                        ]
                    }, idx))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomersMarquee);


/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 28565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);




const ClmShowcaseSection = (param)=>{
    let { heading , desc , showcaseData  } = param;
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [underlineWidth, setUnderlineWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const activeItem = showcaseData[activeIndex];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setUnderlineWidth(0); // Reset underline width
        const duration = activeItem.videoLength * 1000; // duration in ms
        const steps = duration / 100; // update every 100ms
        const increment = 100 / steps;
        let currentWidth = 0;
        const interval = setInterval(()=>{
            currentWidth += increment;
            if (currentWidth >= 100) {
                clearInterval(interval);
                setActiveIndex((prev)=>(prev + 1) % showcaseData.length); // advance to next
            }
            setUnderlineWidth(Math.min(currentWidth, 100));
        }, 100);
        return ()=>clearInterval(interval); // clear interval on unmount or index change
    }, [
        activeIndex
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl leading-snug mx-auto font-semibold w-[850px] max-w-full",
                children: heading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mt-5 w-[85%] md:w-[50%] mx-auto text-[18px] font-medium max-w-full",
                children: desc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:flex-row md:flex hidden flex-col mt-20 justify-center items-center w-full gap-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 md:w-auto w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-col ",
                            children: showcaseData.map((item, idx)=>{
                                const isActive = activeIndex === idx;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: "relative h-[46px] bg-transparent border-t  text-gray-600 flex justify-start items-center gap-4 hover:bg-black/ ".concat(isActive ? "border-gray-900 font-bold" : "border-gray-300"),
                                    onClick: ()=>setActiveIndex(idx),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "rounded-full border border-black flex justify-center items-center w-7 h-7 font-light ".concat(isActive ? "bg-black text-white" : "text-black bg-transparents"),
                                            children: idx + 1
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "relative z-10 whitespace-nowrap",
                                            children: item.navText
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "absolute top-0 left-0 h-0.5 bg-dark transition-all ease-linear",
                                            style: {
                                                width: isActive ? "".concat(underlineWidth, "%") : "0%"
                                            }
                                        })
                                    ]
                                }, item.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md:w-[490px] md:h-[752px] w-[60%] h-auto md:rounded-[40px] rounded-[20px] border-white border-[10px] overflow-hidden",
                        children: [
                            activeItem.imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                src: activeItem.imgSrc,
                                alt: "video",
                                width: 490,
                                height: 752,
                                className: "w-full h-full object-cover"
                            }),
                            !activeItem.imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                className: "w-full h-full object-cover",
                                src: activeItem.videoURL,
                                autoPlay: true,
                                muted: true,
                                loop: true
                            }, activeItem.videoURL)
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex-1 text-left",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-2xl md:text-4xl leading-snug mt-2 font-bold",
                                children: activeItem.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mt-6 text-[18px] leading-[26px] font-medium mb-10",
                                children: activeItem.desc
                            }),
                            activeItem.buttonText && activeItem.buttonClickURL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .CLMButtonPrimary */ .IS, {
                                buttonText: activeItem.buttonText,
                                buttonUrl: activeItem.buttonClickURL
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex md:hidden flex-col gap-16 w-full mt-20 ",
                children: showcaseData.map((item, idx)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: " w-full",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex-1 md:w-auto w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: "relative h-[46px] bg-transparent border-t text-gray-600 flex justify-start items-center gap-4 hover:bg-black/5 border-gray-900 font-bold w-full",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "rounded-full border border-black flex justify-center items-center w-7 h-7 font-light bg-black text-white",
                                            children: idx + 1
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "relative z-10",
                                            children: item.navText
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: " flex-1 text-left ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-2xl leading-snug mt-2 font-semibold",
                                        children: item.heading
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-6 mb-10",
                                        children: item.desc
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-[60%] h-auto rounded-[20px] border-white border-[10px] overflow-hidden mx-auto",
                                children: [
                                    item.imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: item.imgSrc,
                                        alt: "video",
                                        width: 490,
                                        height: 752,
                                        className: "w-full h-full object-cover"
                                    }),
                                    !item.imgSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                        className: "w-full h-full object-cover",
                                        src: item.videoURL,
                                        autoPlay: true,
                                        muted: true,
                                        loop: true
                                    }, item.videoURL)
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full text-center mt-10",
                                children: activeItem.buttonText && activeItem.buttonClickURL && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .CLMButtonSecondary */ .f6, {
                                    buttonText: item.buttonText,
                                    buttonUrl: item.buttonClickURL
                                })
                            })
                        ]
                    }, item.id);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClmShowcaseSection);


/***/ }),

/***/ 7434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export companyLogos */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97005);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CaseStudyHoverCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23660);
/* harmony import */ var _case_studies_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15991);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);









const companyLogos = [
    {
        url: "9.png",
        name: "ABC Eyecare",
        haveCaseStudy: true,
        companyKey: "abc-eyecare".toLowerCase()
    },
    {
        url: "5.png",
        name: "Angelfire",
        haveCaseStudy: true,
        companyKey: "angel-fire".toLowerCase()
    },
    {
        url: "10.png",
        name: "G & H Transport",
        haveCaseStudy: true,
        companyKey: "g-h-transport".toLowerCase()
    },
    {
        url: "4.png",
        name: "Beaver",
        haveCaseStudy: true,
        companyKey: "beaver".toLowerCase()
    },
    {
        url: "2.png",
        name: "Shine Above",
        haveCaseStudy: true,
        companyKey: "shine-above".toLowerCase()
    },
    {
        url: "1.png",
        name: "Harry Corry",
        haveCaseStudy: true,
        companyKey: "harry-corry-ltd".toLowerCase()
    },
    {
        url: "6.png",
        name: "Rethink",
        haveCaseStudy: true,
        companyKey: "rethink".toLowerCase()
    },
    {
        url: "12.png",
        name: "Overstock Furniture",
        haveCaseStudy: true,
        companyKey: "overstock-furniture".toLowerCase()
    },
    {
        url: "11.png",
        name: "Lifestyle Design",
        haveCaseStudy: true,
        companyKey: "lifestyle-design".toLowerCase()
    },
    {
        url: "7.png",
        name: "Mancosa",
        haveCaseStudy: true,
        companyKey: "mancosa".toLowerCase()
    },
    {
        url: "3.png",
        name: "Aging Comfort",
        haveCaseStudy: true,
        companyKey: "aging-comfort".toLowerCase()
    },
    {
        url: "8.png",
        name: "Benavest",
        haveCaseStudy: true,
        companyKey: "benavest".toLowerCase()
    }
];
const generateTestimonials = (companyKey)=>{
    let caseStudy = caseStudies.find((caseStudy)=>caseStudy.key === companyKey);
    if (!caseStudy) {
        caseStudy = caseStudies.find((caseStudy)=>caseStudy.key === "harry-corry-ltd");
    }
    const testimonial = {
        logo: caseStudy.companyLogo,
        company: caseStudy.name,
        quote: caseStudy.customerInsight.insight,
        name: caseStudy.customerInsight.by,
        title: caseStudy.customerInsight.authorPosition,
        avatar: caseStudy.customerInsight.image
    };
    return testimonial;
};
const AnimatedLogos = (param)=>{
    let { isInvert =false  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [hoveredIdx, setHoveredIdx] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const [hoveredKey, setHoveredKey] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const [hoverPosition, setHoverPosition] = react__WEBPACK_IMPORTED_MODULE_1__.useState({
        x: 0,
        y: 0
    });
    const handleLogoClick = (companyKey)=>{
        router.push("/signature/case-studies/".concat(companyKey));
    };
    const handleMouseEnter = (param)=>{
        let { idx , companyKey , event  } = param;
        const rect = event.currentTarget.getBoundingClientRect();
        const marqueeRect = event.currentTarget.closest(".marquee-container").getBoundingClientRect();
        // Calculate position relative to the marquee container
        const x = rect.left - marqueeRect.left + rect.width / 2;
        const y = rect.top - marqueeRect.top;
        let formattedY = y - 280;
        if (companyKey === "angelfire") {
            formattedY = y - 320;
        } else if (companyKey === "mancosa") {
            formattedY = y - 380;
        } else if (companyKey === "beaver") {
            formattedY = y - 320;
        }
        setHoverPosition({
            x,
            y: formattedY
        });
        setHoveredIdx(idx);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full overflow-visible relative h-fit ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "marquee-container relative overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                gradient: false,
                speed: 40,
                className: " overflow-hidden p-2 rounded-md",
                pauseOnHover: true,
                children: companyLogos.map((logo, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-8 flex flex-col items-center group cursor-pointer relative h-[144px]",
                        onClick: ()=>handleLogoClick(logo.companyKey),
                        onMouseEnter: (e)=>handleMouseEnter({
                                idx,
                                companyKey: logo.companyKey,
                                event: e
                            }),
                        onMouseLeave: ()=>setHoveredIdx(null),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative h-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/company/").concat(logo.url),
                                alt: logo.name,
                                className: "object-contain transition duration-300 group-hover:filter ".concat(isInvert ? "invert" : ""),
                                width: 120,
                                height: 120,
                                loading: "lazy"
                            })
                        })
                    }, idx))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnimatedLogos);


/***/ }),

/***/ 23660:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




const CaseStudyHoverCard = (param)=>{
    let { logo , company , quote , name , title , avatar , className =""  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "bg-white shadow-lg hover:shadow-xl rounded-2xl p-5 w-80 max-w-sm border border-gray-50 z-50 transition-all duration-300 ".concat(styles.fadeScaleIn, " ").concat(className),
        style: {
            pointerEvents: "auto"
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 mb-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative w-10 h-10 rounded-lg overflow-hidden bg-gray-50 shrink-0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: logo,
                            alt: company,
                            fill: true,
                            className: "object-contain"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-semibold text-gray-900 text-base",
                        children: company
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("blockquote", {
                className: "text-gray-600 text-sm mb-4 leading-relaxed line-clamp-3 italic",
                children: quote
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-3 border-gray-100"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 mt-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative w-8 h-8 rounded-full overflow-hidden bg-gray-50 ring-2 ring-gray-100 shrink-0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: avatar || "https://avatar.iran.liara.run/public/boy?username=".concat(name),
                            alt: name,
                            fill: true,
                            className: "object-cover"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "font-semibold text-gray-900 text-xs",
                                children: name
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-gray-500 text-[10px] mt-0.5",
                                children: title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CaseStudyHoverCard)));


/***/ }),

/***/ 95291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ industryLeadersCard; }
/* harmony export */ });
// export const industryLeadersCard = [
//   {
//     tag: "1. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "Simple, straight to the point, with a lot of new features coming up. Great!",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "2. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     subTitle: "",
//     subDesc: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "3. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "4. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "5. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "6. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
//   {
//     tag: "7. marketplace",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote:
//       "The onboarding package was exceptionally beneficial and responsive. The team quickly adapted and addressed our evolving needs, ensuring our requirements were met.",
//     author: "Sebastian Lozano",
//     authorTitle: "Sr. Product Manager at Redfin",
//   },
//   {
//     tag: "8. fintech",
//     logo: "https://sendbird.imgix.net/cms/maya_logo.svg",
//     quote: "",
//     author: "",
//     authorTitle: "",
//     percentage: "56%",
//     achievement: "Cost reduction on support cases",
//   },
// ];
const industryLeadersCard = [
    {
        tag: "marketplace",
        logo: "greenleaf.png",
        quote: "Simple, straight to the point, with a lot of new features coming up. Great!",
        author: "Jonathan S.",
        authorTitle: "Marketing Manager"
    },
    {
        tag: "fintech",
        logo: "elemenopillows.png",
        quote: "BoloForms transformed document signing with a user-friendly interface, secure e-signatures, and seamless customization, streamlining our procedures.",
        author: "Juan Diego P.",
        authorTitle: "Operations Executive"
    },
    {
        tag: "marketplace",
        logo: "techsolutions.png",
        quote: "It's cheap and it just works! I had to do mass signatures of our team members and Boloforms made it easy for us to get signatures from our team faster.",
        author: "Sam K.",
        authorTitle: "Sales Lead"
    },
    {
        tag: "fintech",
        logo: "freshstart.png",
        quote: "Finally a simple to use yet full featured PDF signature app!",
        author: "Lisa Brown",
        authorTitle: "Owner"
    },
    {
        tag: "delivery",
        logo: "rappi.png",
        quote: "BoloForms made our document workflows seamless. The intuitive interface and reliable e-signatures significantly improved our team’s efficiency.",
        author: "Groham ",
        authorTitle: "Head of Product"
    }
];


/***/ }),

/***/ 38557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; },
  "showcaseData": function() { return /* binding */ showcaseData; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
;// CONCATENATED MODULE: ./assets/clm/test-build-evaluate.png
/* harmony default export */ var test_build_evaluate = ({"src":"/_next/static/media/test-build-evaluate.31d270c3.png","height":640,"width":1280,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAGFBMVEXw8PD////f3dv////6+vn18/K4uLiIh4dVBNoWAAAAA3RSTlOoqKiTztU9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nB3BgQ0AMAzCsFCg/f/jSbMZxIih9p1b6uw6AfQ9BmEAWAU/jUkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/minus.js
var minus = __webpack_require__(7314);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/plus.js
var plus = __webpack_require__(31012);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(13114);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/components/motion/proxy.mjs + 243 modules
var proxy = __webpack_require__(17568);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 1 modules
var use_in_view = __webpack_require__(16893);
// EXTERNAL MODULE: ./components/CLM/v3/Buttons.jsx
var Buttons = __webpack_require__(56475);
// EXTERNAL MODULE: ./components/CLM/ShowCase/index.jsx
var ShowCase = __webpack_require__(28565);
// EXTERNAL MODULE: ./components/CLM/FAQ2/index.jsx
var FAQ2 = __webpack_require__(74791);
// EXTERNAL MODULE: ./components/customers/AnimatedLogos.jsx
var AnimatedLogos = __webpack_require__(7434);
// EXTERNAL MODULE: ./constants/customersData.js
var customersData = __webpack_require__(95291);
// EXTERNAL MODULE: ./components/CLM/Customers/index.jsx
var Customers = __webpack_require__(5297);
;// CONCATENATED MODULE: ./pages/index.jsx















const cards = [
    {
        id: 1,
        image: "1.png"
    },
    {
        id: 2,
        image: "2.png"
    },
    {
        id: 3,
        image: "3.png"
    },
    {
        id: 4,
        image: "4.png"
    },
    {
        id: 5,
        image: "5.png"
    },
    {
        id: 6,
        image: "6.png"
    },
    {
        id: 7,
        image: "7.png"
    }
];
const customerServiceFaqData = [
    {
        question: "What makes BoloSign’s CLM different from other solutions?",
        answer: "Most CLMs focus on just document storage or eSignatures. BoloSign is designed to streamline the full contract lifecycle — from template creation and negotiation to signature, version tracking, clause redlines, and AI insights. It’s simple enough for teams to adopt quickly, but powerful enough for complex enterprise workflows."
    },
    {
        question: "Can BoloSign integrate with the tools we already use?",
        answer: "Absolutely. BoloSign offers native and API-based integrations with Salesforce, HubSpot, Google Workspace, Slack, Outlook, and more. Whether it’s auto-generating a contract from a CRM or syncing status updates to Slack, your teams won’t have to change the way they work — we just make it faster."
    },
    {
        question: "How secure is our data on BoloSign?",
        answer: "Very. BoloSign is built on enterprise-grade security standards, including SOC 2, ISO 27001, data encryption at rest and in transit, access controls, and detailed audit logs. We also support role-based permissions, so your sensitive data stays exactly where it should."
    },
    {
        question: "Is BoloSign’s AI legally reliable for contract edits and summaries?",
        answer: "Yes, and here’s how: Our AI, Certius, doesn’t just guess — it works off your custom playbooks, fallback clauses, and negotiation history. You’re always in control, and every AI-suggested edit can be accepted, rejected, or modified. Think of it like a super-fast junior legal assistant that never sleeps."
    },
    {
        question: "Can I manage contracts for multiple teams or business units in one place?",
        answer: "Yes — that’s exactly what BoloSign’s Workspaces and Legal Hubs are built for. You can create segmented contract folders, workflows, and templates for Legal, Sales, HR, Procurement, and more — all under one roof, with cross-team visibility and control."
    },
    {
        question: "How fast can we get started with BoloSign?",
        answer: "Faster than most CLMs. You can import your existing contracts, set up clickwraps and eSign templates, and start tracking status in under a week. Our customer success team will guide you through onboarding, or you can go hands-on right away — it’s that intuitive."
    }
];
const transparentFaqData = [
    {
        question: "Compliant with Global eSign Laws:",
        answer: "Ensure every document you send or sign adheres to global eSignature laws like ESIGN, UETA, and eIDAS—helping your business stay legally compliant across borders.",
        image: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/transparent-ai/1.png")
    },
    {
        question: "End-to-end document encryption:",
        answer: "Keep your data secure from sender to signer with robust encryption protocols that ensure confidentiality, integrity, and trust at every step.",
        image: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/transparent-ai/2.png")
    },
    {
        question: "Data governance",
        answer: "Your documents and data stay in your control. We don’t access, store, or share your information, ensuring full alignment with your organization’s data governance standards.",
        image: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/transparent-ai/3.png")
    },
    {
        question: "Privacy & security",
        answer: "Every document is protected with strict privacy controls and enterprise-grade security, ensuring only authorized users can view, sign, or access your data",
        image: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/transparent-ai/4.png")
    }
];
const enterprise = [
    {
        title: "Expert Support & Services",
        desc: "We configure signature workflows, enforce compliance, and enable every feature.",
        img: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/enterprise/1.png"),
        color: "#ffffff"
    },
    {
        title: "Worldwide Customer Success",
        desc: "Get best-practice guidance at launch, during updates, and at renewal.",
        img: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/enterprise/2.png"),
        color: "#ffffff"
    },
    {
        title: "24/7 Support Access",
        desc: "Access live support via chat, email, or phone—24/7.",
        img: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/enterprise/3.png"),
        color: "#000000"
    },
    {
        title: "Custom Plans for Business Continuity",
        desc: "Enjoy SLA-backed uptime guarantees and priority issue resolution.",
        img: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/enterprise/4.png"),
        color: "#000000"
    }
];
const showcaseData = [
    {
        id: 1,
        navText: "Click Through",
        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/showcase/Clickthrough.gif"),
        // icon: "https://sendbird.imgix.net/cms/Anywhere-logo.svg",
        heading: "Centralized Terms Management",
        desc: "Quickly update, publish, and track your terms—ensuring users always access the latest version without IT delays.",
        buttonText: "See how it works",
        buttonClickURL: "/clm/clickThrough",
        videoLength: 12
    },
    {
        id: 2,
        navText: "Repository",
        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/showcase/Repository.gif"),
        // icon: "https://sendbird.imgix.net/cms/Anywhere-logo.svg",
        heading: "Smart, centralized contract management",
        desc: "BoloSign centralizes your contracts, automatically enriches metadata with AI, and ensures quick, secure access to essential contract details.",
        buttonText: "Learn more",
        buttonClickURL: "/clm/repository",
        videoLength: 9
    },
    {
        id: 3,
        navText: "BoloSign AI",
        videoURL: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/videos/home/showcase/BoloSignAI.mp4"),
        // icon: "https://sendbird.imgix.net/cms/Anywhere-logo.svg",
        heading: "Auto-Generate Smart Intake Forms",
        desc: "AI transforms contract fields into dynamic questionnaires, collecting accurate inputs from business teams without legal back-and-forth.",
        buttonText: "Explore the platform",
        buttonClickURL: "/clm/",
        videoLength: 11
    },
    {
        id: 4,
        navText: "Legal AI",
        videoURL: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/videos/home/showcase/LegalAgent.mp4"),
        // icon: "https://sendbird.imgix.net/cms/Anywhere-logo.svg",
        heading: "Context-Aware Legal AI",
        desc: "AI trained on legal language, clause types, and context—so it gets what “termination for convenience” actually means.",
        buttonText: "Discover now",
        buttonClickURL: "/clm/ai-assistant",
        videoLength: 12
    }
];
const CardCycle = ()=>{
    const MAX_VISIBLE = 4;
    const [cardQueue, setCardQueue] = (0,react.useState)(cards);
    const [exitingId, setExitingId] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            setExitingId(cardQueue[0].id);
            setTimeout(()=>{
                setCardQueue((prev)=>{
                    const [first, ...rest] = prev;
                    return [
                        ...rest,
                        first
                    ];
                });
                setExitingId(null);
            }, 200);
        }, 3000);
        return ()=>clearInterval(interval);
    }, [
        cardQueue
    ]);
    const visibleCards = cardQueue.slice(0, MAX_VISIBLE);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-80 w-full px-4 md:px-0 flex justify-center items-center absolute bottom-[-160px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative w-full md:w-[475px] h-[160px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: visibleCards.map((card, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(proxy/* motion.div */.E.div, {
                        layout: true,
                        initial: {
                            opacity: 0,
                            y: 40,
                            scale: 0.95
                        },
                        animate: {
                            scale: 1 - index * 0.1,
                            y: exitingId === card.id ? 40 : index * -25,
                            opacity: exitingId === card.id ? 0 : 1 - index * 0.1,
                            zIndex: cards.length - index,
                            filter: "blur(".concat(index, "px)")
                        },
                        exit: {
                            opacity: 0,
                            y: 40,
                            transition: {
                                duration: 0.3
                            }
                        },
                        transition: {
                            duration: 0.4,
                            ease: "easeInOut"
                        },
                        className: "absolute w-full md:w-auto top-0 left-0 right-0 bg-white rounded-xl shadow-lg text-sm p-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/top-cards/").concat(card.image),
                            width: 534,
                            height: 188,
                            alt: "AI agent",
                            loading: "lazy"
                        })
                    }, card.id))
            })
        })
    });
};
function FaqList(param) {
    let { faqs  } = param;
    var _faqs_;
    const [openIndex, setOpenIndex] = (0,react.useState)(null);
    const currentImage = (_faqs_ = faqs[openIndex || 0]) === null || _faqs_ === void 0 ? void 0 : _faqs_.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex md:flex-row flex-col gap-8 mt-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1 md:block hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: currentImage,
                    alt: "transparent-ai",
                    className: "flex-1 rounded-xl",
                    width: 620,
                    height: 430,
                    loading: "lazy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "border-t border-gray-300",
                    children: faqs.map((faq, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FaqItem, {
                            faq: faq,
                            isOpen: openIndex === index,
                            onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                        }, index))
                })
            })
        ]
    });
}
function FaqItem(param) {
    let { faq , isOpen , onToggle  } = param;
    const { question , answer , image  } = faq;
    const contentRef = (0,react.useRef)(null);
    const [height, setHeight] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-4 py-5 border-b border-gray-300 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: onToggle,
                className: "flex justify-between items-center w-full text-left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: " text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(minus/* default */.Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(plus/* default */.Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3 text-gray-700 text-[18px] leading-[26px]",
                        children: answer
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 md:hidden block mt-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image,
                            alt: "transparent-ai",
                            className: "flex-1",
                            width: 620,
                            height: 430,
                            loading: "lazy"
                        })
                    })
                ]
            })
        ]
    });
}
const Home = ()=>{
    function GradientHeading() {
        const headingRef = (0,react.useRef)(null);
        const inView = (0,use_in_view/* useInView */.Y)(headingRef, {
            amount: 0.4,
            once: false
        });
        const gradientText = (text)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "inline-block mr-1 transition-colors duration-700 ".concat(inView ? "bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500 bg-clip-text text-transparent" : "text-gray-400"),
                children: text
            });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: headingRef,
            className: "\n        transition-opacity duration-[1000ms] \n        ".concat(inView ? "opacity-100" : "opacity-50", "\n        text-gray-800\n      "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "text-4xl md:text-[60px] md:leading-[64px] mx-auto text-center font-normal",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block",
                            children: [
                                "The ",
                                gradientText("AI workforce"),
                                " humans can lean on."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block",
                            children: [
                                "Never tires, never quits, and ",
                                gradientText("always improves")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block",
                            children: [
                                "Scale to meet ",
                                gradientText("any demand"),
                                "."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-4 text-gray-600 w-[70%] md:w-full mx-auto text-base md:text-lg text-center ",
                    children: "End-to-End Contract Automation with CLM, eSignatures, and AI—All in One Place"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "BoloSign - AI for Smart Contract Management"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "BoloSign is your AI assistant for smart contract management. Draft, review, and eSign contracts on autopilot with our all-in-one CLM solution."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "BoloSign, AI contract management, smart contract management, CLM, eSignatures, legal AI, contract automation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "BoloSign - AI for Smart Contract Management"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "BoloSign is your AI assistant for smart contract management. Draft, review, and eSign contracts on autopilot with our all-in-one CLM solution."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign - AI for Smart Contract Management"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "BoloSign is your AI assistant for smart contract management. Draft, review, and eSign contracts on autopilot with our all-in-one CLM solution."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "text-white relative h-[600px] md:h-[750px] bg-dark",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        autoPlay: true,
                        loop: true,
                        muted: true,
                        className: "absolute top-0 left-0 w-full h-full object-cover z-0 overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/videos/bgAnimation.mp4"),
                            type: "video/mp4"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-10 flex flex-col items-center justify-start gap-6 h-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center justify-center gap-4 md:gap-6 md:mt-20 mt-8 w-full ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-4xl leading-[48px] md:text-[92px] md:leading-[92px] text-center max-w-full md:max-w-[950px] font-semibold",
                                        children: "AI for Smart Contract Management"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-base md:text-2xl text-center max-w-[750px] w-[70%] md:w-full",
                                        children: "Your AI assistant to draft, review, and eSign contracts on autopilot."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMButtonSecondary */.f6, {
                                        buttonText: "Request Demo",
                                        buttonUrl: "clm/request-demo"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[100%] md:w-[90%] relative mt-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pointer-events-none absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-[#1b1b1b] to-transparent z-10 hidden md:block"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pointer-events-none absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-[#1b1b1b] to-transparent z-10 hidden md:block"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedLogos/* default */.Z, {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardCycle, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: " text-black py-16 px-2 md:px-8 text-center md:mt-32 mt-16 z-10 relative max-w-screen-xl mx-auto ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientHeading, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-2 md:px-0 mt-12 mb-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/videos/home/workspace.mp4"),
                            className: "w-full",
                            autoPlay: true,
                            loop: true,
                            muted: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMButtonPrimary */.IS, {
                        buttonText: "View AI Agent Platform",
                        buttonUrl: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-[#f4f2f0]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-screen-xl md:px-8 px-4 mx-auto py-20 text-gray-900 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowCase/* default */.Z, {
                            showcaseData: showcaseData,
                            heading: "A Complete Contract Management Solution",
                            desc: "One-click approvals, a secure document repository, and built-in Legal AI for instant drafting, review, and signing."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex md:flex-row flex-col md:gap-2 gap-8 mt-36 mb-10 justify-center items-center w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "md:w-[80%] md:text-left text-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "text-4xl md:text-5xl font-semibold leading-snug ",
                                                children: "Contracting made simple: CLM + eSignature + AI"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-6 md:text-[22px] text-gray-800 mb-10",
                                                children: "Simplify contract creation, accelerate signing, and automate approvals—with AI at every step."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMButtonPrimary */.IS, {
                                                buttonText: "View AI Agent Builder",
                                                buttonUrl: "/clm/signature"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:w-[650px] max-w-full rounded-[20px] overflow-hidden ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/command-ai.gif"),
                                        alt: "test-build-evaluate",
                                        width: 100,
                                        height: 100,
                                        className: "w-full h-full object-cover",
                                        loading: "lazy"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "bg-[#0d0d0d] pb-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-white py-16 md:px-8 px-4 max-w-screen-xl mx-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "text-4xl md:text-5xl md:mt-10 mt-8 font-semibold md:text-left text-center",
                                style: {
                                    lineHeight: 1.1
                                },
                                children: [
                                    "Connecting the world with AI agents. ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " 5 million users and counting."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-4 grid-rows-2 gap-3 mt-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "md:col-span-2 md:row-span-2 col-span-4 relative rounded-xl overflow-hidden md:h-auto h-[170px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/connecting-world/1.png"),
                                                width: 498,
                                                height: 700,
                                                alt: "Scalable and compliant",
                                                className: "object-cover w-full h-full",
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "absolute top-0 left-0 w-full h-full md:w-[70%] md:p-10 p-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-left md:text-5xl text-3xl font-semibold",
                                                        children: "Secure and Compliant"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/inside-globe.png"),
                                                        // src={require("../assets/clm/inside-globe.png")}
                                                        alt: "inside-globe",
                                                        className: " h-[46px] md:h-[78px] w-auto md:mt-5 mt-2",
                                                        width: 46,
                                                        height: 78,
                                                        loading: "lazy"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "md:col-span-2 md:row-span-1 col-span-4 relative rounded-xl overflow-hidden md:h-auto h-[170px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/connecting-world/2.png"),
                                                alt: "meeting",
                                                className: "object-cover w-full h-full",
                                                width: "200",
                                                height: "100",
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "absolute top-0 left-0 w-full h-full md:p-6 p-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-left md:text-6xl text-3xl font-semibold",
                                                        children: "300k+"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-left text-xl",
                                                        children: "Organizations globally"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: " md:col-span-1 col-span-2 rounded-xl relative overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/connecting-world/3.png"),
                                                alt: "graph",
                                                className: "object-cover w-full h-full",
                                                width: "200",
                                                height: "100",
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "absolute top-0 left-0 w-full h-full md:p-6 p-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-left md:text-6xl text-3xl font-semibold",
                                                        children: "150K+"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-left md:text-xl text-base",
                                                        children: "Documents signed monthly"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "md:col-span-1 col-span-2 rounded-xl overflow-hidden relative ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/home/connecting-world/4.png"),
                                                alt: "uptime",
                                                className: "object-cover w-full h-full",
                                                width: "100",
                                                height: "100",
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "absolute top-0 left-0 w-full h-full md:p-6 p-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-left md:text-6xl text-3xl font-semibold",
                                                        children: "99.95%"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-left md:text-xl text-base",
                                                        children: "Platform availability"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "text-4xl md:text-5xl md:text-left text-center font-semibold md:mt-44 mt-20",
                                style: {
                                    lineHeight: 1.1
                                },
                                children: [
                                    "Industry leaders fly with BoloSign ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " It's your turn to rise with AI."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Customers/* default */.Z, {
                        customersData: customersData/* industryLeadersCard */.Z
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-[#f4f2f0] ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-black py-16 md:px-8 px-4 max-w-screen-xl mx-auto text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-4xl md:text-5xl leading-snug md:text-left text-center font-semibold",
                            children: "Legally compliant eSignatures on a secure platform."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-6 text-gray-600 md:text-[22px] md:leading-[31px] text-[18px] md:text-left text-center",
                            children: "Digitally sign documents — built for businesses that prioritize security, compliance, and peace of mind."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqList, {
                            faqs: transparentFaqData
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-4xl md:text-5xl leading-snug md:mt-48 mt-24 md:text-left text-center font-semibold",
                                    children: "Enterprise-Grade Support for Your Digital Workflows"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-6 text-gray-600 md:text-[22px] leading-[31px] md:text-left text-center text-[18px]",
                                    children: "Our team brings deep expertise in eSignatures, automation, integrations, and document workflows—helping you confidently scale with BoloSign."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 flex gap-4 md:overflow-x-hidden overflow-x-auto overflow-y-hidden snap-x snap-mandatory",
                                    style: {
                                        scrollbarWidth: "none",
                                        msOverflowStyle: "none"
                                    },
                                    children: enterprise.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative flex-shrink-0 md:flex-shrink snap-start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: item.img,
                                                    alt: item.title,
                                                    width: 305,
                                                    height: 480,
                                                    className: "rounded-2xl",
                                                    loading: "lazy"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "w-[285px] h-[480px] absolute top-0 left-0 px-[24px] py-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: " text-[26px] font-bold leading-[28px]",
                                                            style: {
                                                                color: item.color || "#fff"
                                                            },
                                                            children: item.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-[18px] leading-[22px] mt-6 font-medium",
                                                            style: {
                                                                color: item.color || "#fff"
                                                            },
                                                            children: item.desc
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, index))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ2/* default */.Z, {
                    faqData: customerServiceFaqData,
                    heading: "FAQs"
                })
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ })

}]);